import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { Label } from '@/components/ui/label';
import { TextFilter } from '@/shared/ui/filters';

interface ConsignmentNumberFilterProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function ConsignmentNumberFilter({
  value,
  onChange,
  className = 'w-full md:w-64'
}: ConsignmentNumberFilterProps) {
  const { t } = useTranslation();
  const id = useId();

  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={id} className="text-sm font-medium">
        Consignment Number
      </Label>
      <TextFilter
        id={id}
        name="consignment-number"
        value={value}
        onChange={onChange}
        placeholder={t('dashboard.consignment.placeholder', 'Enter consignment number')}
        className={className}
      />
    </div>
  );
}
